// hc-soldout V1.2.1
function HcUpdateCrossedOut(opts) { 
  const {
    variants, // {{ product.variants | json }}
    options, // {{ product.options | json }}
    optionNames, // ['Size'] the options to update
    selectors, // Selectors
    onDisable
  } = opts;
  
  const {
    radioAllElements: radioAllSelector, // A selector to match all the radio buttons
    radioElement: radioSelector, // the input element with the swatch (index: number): string
    radioContainer: swatchSelector // the parent of the radio button to update 
  } = selectors; 

  const customDisabler = typeof onDisable == 'function' && onDisable;
  
  const disablerFn = customDisabler || ((el, shouldDisable) => el.closest(swatchSelector).classList.toggle('hc-soldout-option', shouldDisable));
  // Get option index by name 
  const getIndex = optionName => options.findIndex(op => op.toLowerCase() == optionName.toLowerCase())  

  // Get available option for $x in ["red", "$x", "long"] 
  function getAvailableOptions(options) {
    const req_index = options.findIndex(opt => opt == "$x");
    if (req_index < 0) throw new TypeError("$x must be passed to the options array");

    return variants
    .filter(variant => {
      for (const [index, opt] of variant.options.entries()) {
        if (!variant.available || (options[index] !== opt && index !== req_index)) return false;
      }
      return true;
    })
    .map(variant => variant.options[req_index]);
  }
  
  
  function getPossibleOptions(options) {
    const req_index = options.findIndex(opt => opt == "$x");
    if (req_index < 0) throw new TypeError("$x must be passed to the options array");

    return variants
    .filter(variant => {
      for (const [index, opt] of variant.options.entries()) {
        if ((options[index] !== opt && index !== req_index)) return false;
      }
      return true;
    })
    .map(variant => variant.options[req_index]);
  }
  
  // Get an array of the selected options similar to variant.options 
  const getSelectedOptions = () => options.map((name, index) => document.querySelector(radioSelector(index) + ':checked').value);
  
  function shouldSoldoutUpdate(optionIndex, optionSelector, newlyPickedSwatchElement) {
    const isSameOption = newlyPickedSwatchElement && newlyPickedSwatchElement.querySelector(optionSelector);
    return (!isSameOption);
  }
  
  function fireUpdateEvent(optionIndex, optionSelector,availableOptions) {
    const e = new CustomEvent('hc-soldout:update',  {
      detail: {
        optionIndex, 
        optionSelector,
        availableOptions,
        optionName: options[optionIndex].toLowerCase()
      }
    });
    document.dispatchEvent(e);
  }
  
  function updateOptions(selectedOptions, changedOption) {
    
    const optionSelectors = optionNames.map(optionName => {
      const optIndex = getIndex(optionName)
      return [optIndex, radioSelector(optIndex)];
    }); 
    
    for (const [requestedOptionIndex, optionSelector] of optionSelectors) {
      if (!shouldSoldoutUpdate(requestedOptionIndex, optionSelector, changedOption)) continue;
      const availableValues = getAvailableOptions(selectedOptions.map((val, index) => index === requestedOptionIndex ? "$x" : val));
      const possibleValues = getPossibleOptions(selectedOptions.map((val, index) => index === requestedOptionIndex ? "$x" : val));
      const radios = document.querySelectorAll(optionSelector);
      radios.forEach(el => disablerFn(el, !availableValues.includes(el.value), !possibleValues.includes(el.value)));
      fireUpdateEvent(requestedOptionIndex, optionSelector, availableValues);
    }
  }
  
  function onLoad() {
    updateOptions(getSelectedOptions());
    document.body.addEventListener('change', e => {
      if (e.hcIgnore) return;
      if (e.target.closest(radioAllSelector)) {
        let selectedOptions;
        if (!selectedOptions) selectedOptions = getSelectedOptions();
        updateOptions(selectedOptions, e.target.closest(swatchSelector));
      }
    });
  }
  
  window.addEventListener('DOMContentLoaded', onLoad);
  
  if (document.readyState === "complete") {
    onLoad();
  }
}

document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('hc-soldout:update', function(e) {
    if(e.detail.availableOptions.length > 0) {
      document.querySelector(`.variant-input.hc-color-swatch[data-value='${e.detail.availableOptions[0]}'] input`).click();
      document.querySelector('.variant__label-info span').innerText = e.detail.availableOptions[0];
    }
  });
});